import lyForm from './lyForm'
import table from './table'
import svgIcon from '../icons'
import sliderVerify from './sliderVerify'
// import uploadImg from './uploadImg'
export const componentsList = [
    lyForm, 
    table, 
    svgIcon,
    sliderVerify
    // uploadImg
]
export const importFnComponents = function (Vue, components) {
      const componentsInstall = (components && Array.isArray(components)) ? [...componentsList, ...components] : [...componentsList]
            componentsInstall.forEach(el => {
           if(el.install && typeof el.install === "function") {
             el.install(Vue)
           }
      });
}

